// extracted by css-extract-rspack-plugin
export default {"accordionListRoot":"I4OMZ","hasSearch":"SgSQw"};